import { combineReducers } from 'redux'
import user from './user'
import composer from './composer'
import chat from './chat'
import plugins from './plugins'

/**
 * Holds all the state of a user conversation.
 * @param state Current state
 * @param action Action to do
 */
const conversation = combineReducers({
  user,
  composer,
  chat,
  plugins,
})

export default conversation
